import Vue from 'vue';
import Vuetify, { VLayout, VCheckbox, VSelect } from 'vuetify/lib';

Vue.use(Vuetify, {
  components: { VLayout, VCheckbox, VSelect },
});

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
      dark: false,
    themes: {
      light: {
        // primary: '#ee44aa',
        primary: '#6F7FD9',
        //secondary: '#424242',
        secondary: '#17467a',
        accent: '#3DD88F',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },
});
